module.exports = __webpack_public_path__ + "static/media/icon_orientation.13994759.svg";